document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll(".size-guide-link").forEach(link=>{
    link.addEventListener("click", function(e){
      e.preventDefault();
      const popup = document.getElementById(this.dataset.popup);
      popup.classList.add("active");
    });
  });

  document.querySelectorAll(".size-guide-close, .size-guide-overlay").forEach(el=>{
    el.addEventListener("click", function(){
      this.closest(".size-guide-popup").classList.remove("active");
    });
  });

});